import React from 'react'
import { Pagination as BPagination, PaginationProps } from 'react-bootstrap'
import './style.scss'

const Pagination = ({ ...rest }: PaginationProps) => {
  return (
    <BPagination
      {...rest}
      className={`${'custom-pagination'} ${rest.className}`}
    />
  )
}

export default Pagination
